import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  basesCount: null,
  basesDetail: {},
  basesList: [],
  formsCount: null,
  formsDetail: {},
  formsList: [],
  linksCount: null,
  linksDetail: {},
  linksList: [],
  ...stateAbstract
}

export default {
  namespaced: true,
  state,
  actions: actionsAbstract,
  mutations: mutationsAbstract
}
